import styled from "styled-components";
import theme from "../../theme/theme";

const LimitedScopeWrapper = styled.section`
  box-sizing: border-box;
  background-color: #fff;
  height: 500px;
  max-width: 800px;
  padding: 30px;
  overflow-y: auto;
  border-radius: 8px;

  & h2 {
    color: ${theme.colors.primaryStrong2X};
    font-size: 32px;
    margin: 0 0 30px 0;

    @media (max-width: 480px) {
      font-size: 20px;
    }
  }

  & h3 {
    font-size: 16px;
    margin: 0;
  }

  & p {
    margin: 20px 0 30px 0;
    text-align: justify;
    font-size: 14px;
  }
`;

const LimitedScope = () => {
  return (
    <>
      <LimitedScopeWrapper>
        <h2>Limited Scope Liability Agreement</h2>
        <div className="paragraph">
          <h3>
            Strategy Marketplace, LLC is a registered investment advisory firm,
            DBA TACTIVE.
          </h3>
          <p>
            This LIMITED SCOPE ADVISORY AGREEMENT (the “Agreement”) is entered
            into between Client (“Limited Client”) and between STRATEGY
            MARKETPLACE, LLC, DBA TACTIVE (“Advisor”) a limited liability
            corporation. Subject to the terms of this Agreement the Limited
            Client understands that Advisor is not being engaged to provide
            discretionary investment services pursuant to Advisor’s investment
            management Program (“Program” as defined below) which governed by
            the Client Agreements (as defined below). Inconsideration of the
            mutual covenants and agreements set forth herein and other good and
            valuable consideration the Client and Adviser agree as follows{" "}
          </p>
        </div>
        <div className="paragraph">
          <h3>1. Appointment of Investment Advisor </h3>
          <p>
            Limited Client hereby appoints Advisor to render services for
            Client’s Account (collectively the “Account”) under the terms and
            conditions set forth in the Agreement. By execution of this
            Agreement, Adviser accepts this Limited appointment as investment
            adviser.{" "}
          </p>
        </div>
        <div className="paragraph">
          <h3>2. Program Services by Advisor </h3>
          <p>
            By execution of this Agreement, Advisor hereby accepts the
            appointment as investment adviser for the Account and agrees, as of
            the effective date of the Agreement set forth in the signature page
            below, to provide the following services.{" "}
          </p>
        </div>
        <div className="paragraph">
          <h3>3. Client Information </h3>
          <p>
            It is understood and agreed that Advisor, in the maintenance of
            records for its own purposes, or in making such records or the
            information contained therein available to Limited Client or any
            other person at the direction of the Limited Client, does not assume
            responsibility for the accuracy of information furnished by the
            Limited Client or any other person.{" "}
          </p>
        </div>
        <div className="paragraph">
          <h3>4. Limited Client is defined</h3>
          <p>
            as Individuals receiving Services or accessing a Profile through the
            Platform who have entered into a limited scope advisory relationship
            with Advisor. An individual who is not logged into the Interface or
            not receiving Services is not a Limited Client. For avoidance of
            doubt, a corporation or other entity, and the trustee, agent,
            representative, nominee or beneficiary of that entity is not a
            Limited Client.
          </p>
        </div>
        <div className="paragraph">
          <h3>5. Limited Client Representations </h3>
          <p>
            By entering into this Limited Scope Agreement, Limited Client also
            acknowledges receipt of the Advisory Privacy Policy, the ADV Parts
            2A and 3 (found within the Website). If Limited Client elects to
            participate in the Program and agrees electronically to the specific
            terms and conditions of the Client Agreements, this Limited Scope
            Agreement will terminate and the terms and conditions of the Client
            Agreements will replace and supersede the terms of this Limited
            Scope Agreement. Advisor reserves the right to modify or terminate
            this Limited Scope Agreement at any time. Up-to-date information
            about the services contemplated by this Limited Scope Agreement will
            be provided via the Website Interface.
          </p>
          <p>
            True and Accurate Information. The information that Limited Client
            provides to Advisor (including any Financial Consultant) as part of
            the Services is incorporated into the Limited Scope Agreement.
            Limited Client attests that such information is or will be current,
            accurate, truthful, and complete. Advisor will not be required to
            independently verify any such information. Advisor shall rely on
            such information and cannot be held responsible for any
            recommendations based on inaccurate or incomplete information.
            Limited Client acknowledges that if Limited Client provides false,
            inaccurate, or incomplete information to Advisor the Services may
            not match Limited Client’s needs. Limited Client agrees to indemnify
            and hold Advisor and its affiliates harmless from and against any
            and all losses arising out of or relating to Limited Client’s
            failure to provide true and accurate information to Advisor or to
            update such information during the term of the Limited Scope
            Agreement.
          </p>
          <p>
            Limited Client Profile. Limited Clients may enter, view, and store
            personal and financial information in a Profile that is connected
            with a Limited Client’s unique User ID and Password. Method of
            Communication; Obligation to Check Website. Limited Client agrees
            that the primary method of Advisor’s communication with Limited
            Client in connection with the provision of Services will be by
            posting information on servers accessible from the Website and, to
            the extent required by law, sending Limited Client a notice that
            directs Limited Client to the Website from which the information can
            be read and printed. Limited Client understands that Advisor
            reserves the right, however, to post Communications (as defined in
            the Consent to Electronic Delivery of Documents) on the Website
            without providing notice to Limited Client, send Communications to
            Limited Client’s postal or electronic mail address of record or to
            another Access Device Limited Client has registered with Advisor.
            Limited Client agrees that all Communications provided to Limited
            Client in any of the ways described above will be deemed to have
            been good and effective delivery to Limited Client when sent or
            posted by Advisor, regardless of whether Limited Client actually or
            timely receives or accesses the Communication.
          </p>
          <p>
            Limited Scope Services shall include Aggregation Services provided
            or offered by unaffiliated companies, or affiliates of the Advisor.
            Unless otherwise noted, all authority granted to or limitations of
            liability of Advisor shall include its affiliates, agents, and
            representatives, as well as any service provider. Limited Client
            authorizes Advisor and its agents or its affiliates acting on behalf
            of Advisor under this Limited Scope Agreement to perform the
            services contemplated by this Limited Scope Agreement.
          </p>
        </div>
        <div className="paragraph">
          <h3>6. Services by Advisor </h3>
          <p>
            Generally, the Advisor offers Robo Advisory Services (“Services”) to
            Limited Clients through the internet interface within the Website.
            Limited Client must be willing to receive the Services over the
            internet in order to use the Services under this Limited Scope
            Agreement. Advisor provides customer support over the telephone and
            internet for purposes of technical support, but such support is
            educational in nature only.
          </p>
          <p>
            Services Features. Services include financial goal identification,
            retirement planning and features that allow Limited Clients to
            simulate financial outcomes with various inputs as well as other
            services. Based on Limited Client’s responses to certain specific
            financial questions, Service provides advice and education services
            utilizing Advisor’s investment methodology regarding goal-based
            asset allocation strategies. Among other things, Services are
            intended to give Limited Clients an understanding of how a portfolio
            may grow and support stated financial goals.
          </p>
          <p>
            Services to Other Clients. It is understood that Advisor may perform
            investment advisory services for various clients and that the
            services provided by Advisor are offered/rendered on a non-exclusive
            basis. Limited Client agrees that Advisor may give advice and take
            action in the performance of its duties with respect to any of its
            other clients which may differ with the advice given or action taken
            with respect to the Account. Nothing in this Agreement shall be
            deemed to confer upon Advisor any obligation to acquire for the
            Account a position in any security which Advisor, its principals, or
            its employees may acquire for its or their own accounts or for the
            account of any other client, if in the sole and absolute discretion
            of Advisor it is not for any reason practical or desirable to
            acquire a position in such security for the Account.
          </p>
          <p>
            Supplemental Services. Advisor provides Limited Clients the
            opportunity to receive Supplementary Services. Limited Clients are
            able to schedule telephone consultations with a Financial Consultant
            who will provide personalized financial planning advice, including
            advice 3 relating to debt, such as student loans and credit card
            debt, mortgages, savings, and retirement (including pensions and
            social security) advice that does not constitute legal advice or
            advice requiring licensure as a Certified Public Accountant (such
            advice collectively is referred to as “Supplementary Services”
            whether delivered via telephone consultation or another medium).
            Limited Clients may elect to receive Supplementary Services through
            a package of financial planning advice (“Advice Package”) for a
            fixed fee paid in advance. All available Advice Packages and prices
            are listed in the Advisor’s ADV 2A. Limited Client acknowledges and
            agrees that receipt of Advice Packages is subject to additional
            terms and conditions as set forth within an Advisory Agreement
            separate from the Limited Scope Agreement herein. Advisor reserves
            the right to offer Supplementary Services, in its discretion, at no
            charge.
          </p>
          <p>
            Account Operation: Client has the sole right to withdraw cash from
            the Account at any time in any amount, subject only to Advisor’s
            right to conclude any transactions initiated prior to or at the time
            of such withdrawal. Client may add or deposit money to an account at
            any time. Client acknowledges and agrees that any and all costs,
            expenses, indebtedness, liabilities, losses, gains, or income
            sustained as a result of transactions, and that any ongoing mutual
            fund operating expenses charged by any mutual funds, shall be those
            of Client and the particular account. Advisor however shall pay fees
            charged by third party managers or sub advisors retained by Advisor.
            The forgoing does not change any rights the Client may have under
            applicable Federal or State securities laws.
          </p>
          <p>
            Confidentiality: All information, recommendations and/or advice
            communicated by Advisor to Client here under shall be regarded as
            confidential and shall not be disclosed to any person or entity
            without the prior written consent of Advisor. Advisor will hold in
            strict confidence all information regarding Client’s assets under
            management. Advisor will have no obligation to seek to obtain any
            material nonpublic or insider information about any issuer or
            securities and shall not purchase, sell or recommend for the Account
            any securities of any issuer on the basis of any such information as
            may come into its possession.
          </p>
        </div>
        <div className="paragraph">
          <h3>7. Fees </h3>
          <p>
            Client agrees to pay such fees and charges to Advisor of .65% of
            asset under management within the Account to perform services for
            clients in the Accounts managed by Advisor. The fee charged by
            Advisor will be calculated and paid monthly in arrears based upon
            the closing balance of the Account on the last day of the month.
            Management fees will be automatically deducted from Client’s account
            unless direct billing has been authorized by Advisor. If direct
            billing is not paid within 60 days, fee will be deducted directly
            from Client account. Should a client add funds to an account during
            a billing period the fee will be billed the pro rata fee for the
            remainder of the billing period, and if direct billing has been
            authorized, fee shall be due within 10 days of receipt or fees will
            be deducted from Client Account. In the event of a partial
            withdrawal of funds during a billing period, the pro rata portion of
            the fee will be billed based upon the number of days remaining in
            the billing period. Client understands that the fees charged by
            Advisor may be higher than the fees charged by other advisors for
            similar services.{" "}
          </p>
        </div>
        <div className="paragraph">
          <h3>8. Limited Client Custodian Accounts </h3>
          <p>
            Client agrees to open an account with Interactive Brokers a
            custodian for the execution of securities transactions and custodial
            services. The Custodian at the time this Agreement is executed will
            be identified in the Agreement. Advisor will recommend a Custodian
            and will do so pursuant to Advisor’s duty to seek best execution,
            and review such annually. All Client funds/securities will be
            delivered between the Client and the Custodian only. Client hereby
            authorizes the Advisor to receive from the Custodian a copy of any
            agreement between Client and the Custodian in effect at any time
            with respect to the Account. If the Client elects to us a custodian
            other than the custodian suggested by Advisor, then Advisor may not
            be able to negotiate the best prices. account with a custodian or
            broker/dealer recommended by Advisor. Any applicable custodial fees
            and brokerage transaction fees are billed to the Client by the
            custodian or broker/dealer and are not included in the Advisor’s
            annual management fee.{" "}
          </p>
        </div>
        <div className="paragraph">
          <h3>9. Limitations and Investment Results are Not Guaranteed: </h3>
          <p>
            Limited Client understands and agrees that investment results
            Limited Client could obtain by relying on advice provided through
            the Services cannot be guaranteed and that Advisor is not
            responsible for any investment results. Investment tools provided by
            within the Platform, whether or not through Services, are not a
            guarantee of performance and Advisor does not guarantee or make any
            warranty of any kind, express or implied, regarding the projections
            or recommendations generated by the investment tools. Limited Client
            understands and agrees that Limited Client is responsible for all
            Losses (including lost opportunity or profits) arising from or
            related to the Services, including those relating to discrepancies
            between projections and 4 actual performance. As with Advisor’s
            services more generally, Services are not designed to provide you
            with a comprehensive financial plan. Except for negligence or
            malfeasance or violation of applicable law, Limited Client agrees
            that Advisor and its respective officers and employees shall not be
            liable hereunder for any action performed or omitted to be performed
            or for any errors of judgment in providing Services. Federal and
            state securities laws impose liabilities under certain circumstances
            on persons who act in good faith and therefore nothing herein shall
            in any way constitute a waiver or limitation of any rights which
            Limited Client may have under federal or state securities laws. In
            addition, it is possible that a Limited Client or Advisor itself may
            experience computer equipment failure, loss of internet access,
            viruses, or other events that may impair access to Advisor’s
            software based financial advisory service. Advisor and its
            representatives are not responsible to any Limited Client for Losses
            unless caused by Advisor breaching its fiduciary duty.{" "}
          </p>
        </div>
        <div className="paragraph">
          <h3>10. Term and Termination </h3>
          <p>
            This agreement shall continue until terminated by either party
            according to the following terms. Anything herein to the contrary
            notwithstanding, Limited Client may terminate this Agreement within
            five (5) business days after execution by all parties without
            penalty. This agreement may also be terminated by either Limited
            Client or Advisor upon thirty (30) days prior written notice.{" "}
          </p>
        </div>
        <div className="paragraph">
          <h3>11. Amendment </h3>
          <p>
            Unless stated otherwise in this Agreement, the Advisor may amend
            this Agreement at any time by providing thirty (30) days advance
            notice to Limited Client. If no objection is made by the Limited
            Client within thirty (30) days following delivery of such notice the
            Advisor will assume Limited Client’s inaction constitutes consent.{" "}
          </p>
        </div>
        <div className="paragraph">
          <h3>12. Death or Incompetence of Client: </h3>
          <p>
            In the event that Limited Client should die or become incompetent,
            Advisor’s authority to act pursuant to the terms hereof shall
            continue until such time as Advisor receives written notice of
            Limited Client’s death or incompetence from Limited Client’s
            guardian or other legal representative.{" "}
          </p>
        </div>
        <div className="paragraph">
          <h3>13. Governing Laws </h3>
          <p>
            The Limited Client understands that this Agreement will be deemed to
            have been made in the State of Missouri. To the extent not
            consistent with Federal law, this Agreement shall be governed by and
            construed in accordance with the Laws of Missouri, except to the
            extent preempted by ERISA or other federal or state laws or
            regulations.{" "}
          </p>
        </div>
        <div className="paragraph">
          <h3>14. No Assignment </h3>
          <p>
            No Assignment of this Agreement may be made without Limited Client’s
            consent. The Limited Client’s consent may be given orally, in
            writing or by implied consent (“negative consent”). Limited Client’s
            consent to an assignment may be conclusively presumed if Advisor
            provides Limited Client with written notice describing the proposed
            assignment with an opportunity and method to terminate this
            Agreement not less than 30 days prior to the event, and thereafter,
            Limited Client continues Advisor’s services under this Agreement
            without oral or written objective or contract termination. The
            foregoing does not prevent an assignment by Advisor in connection
            with any transaction which does not result in a change of actual
            control or management, as defined by applicable law.{" "}
          </p>
        </div>
        <div className="paragraph">
          <h3>15. Title to Assets </h3>
          <p>
            Under management by Advisor. Limited Client represents assets in the
            Account belong to Limited Client fee and clear of any lien of
            encumbrances.{" "}
          </p>
        </div>
        <div className="paragraph">
          <h3>16. Market Conditions </h3>
          <p>
            Limited Client acknowledges that Advisor’s past performance and
            advice regarding client accounts cannot guarantee future results. As
            with all Market Investments Limited Client investments can
            appreciate or depreciate. Advisor does not guarantee or warrant that
            services offered will result in profit.{" "}
          </p>
        </div>
        <div className="paragraph">
          <h3>17. Electronic Signatures </h3>
          <p>
            Limited Client’s intentional action in electronically signing this
            Limited Scope Agreement is valid evidence of consent to be legally
            bound by this Limited Scope Agreement and by other documentation
            submitted in the signup process for Services or governing Limited
            Client’s relationship with Advisor. Limited Client acknowledges that
            Limited Client may access and retain a record of the documents that
            Limited Client electronically signs through the link to the location
            on the Interface presented when Limited Client signs up to receive
            Services. Limited Client is solely responsible for reviewing and
            understanding all of the terms and conditions of these documents.
            Limited Client accepts as reasonable and proper notice, for the
            purpose of any and all laws, rules, and regulations, notice by
            electronic means, including the posting of modifications to this
            Limited Scope Agreement on the Interface. The electronically stored
            copy of this Limited Scope Agreement is considered to be the true,
            complete, valid, authentic, and enforceable record of the Limited
            Scope Agreement, admissible in judicial or administrative
            proceedings to the same extent as if the documents and records were
            originally generated and maintained in printed form. Limited Client
            agrees to not contest the admissibility or enforceability of
            Advisor’s electronically stored copy of the Limited Scope Agreement
            in any proceeding arising out of the terms and conditions of the
            Limited Scope Agreement. 5 Electronic Delivery of Documents and
            Updated Contact Information. By entering into this Limited Scope
            Agreement Limited Client acknowledges receipt and acceptance of the
            “Consent to Electronic Delivery of Documents from Advisor” which is
            attached hereto. All written notices to any party under this Limited
            Scope Agreement shall be sent to such party in electronic form
            either through applicable means of the Interface or through
            designated email addresses, or such other address as such party may
            designate in writing to the other. Limited Client is responsible for
            maintaining a valid email address and software and hardware to
            receive, read and send email. Limited Client hereby agrees to
            provide Advisor with a current email address and promptly notify
            Advisor of any changes to his or her email address in his or her
            Profile on the Interface or the Website{" "}
          </p>
        </div>
        <div className="paragraph">
          <h3>18. General and Miscellaneous Provisions and Disclosures </h3>
          <p>
            a. Limited Client represents and confirms that Limited Client has
            full power and authority to execute, deliver, enter into, and
            perform Limited Client’s obligations under this Limited Scope
            Advisory Agreement. Limited Client represents that Limited Scope
            Agreement has been duly authorized, executed, and delivered by
            Limited Client and is the legal, valid, and binding agreement of
            Limited Client, enforceable against Limited Client in accordance
            with its terms, and that the terms of this Limited Scope Agreement
            do not violate any obligation by which the Limited Client is bound,
            whether arising by contract, operation of law, or otherwise.
          </p>
          <p>
            b. Limited Client shall advise Advisor immediately of any event that
            might affect this authority or the binding effect of this Limited
            Scope Agreement.
          </p>
          <p>
            c. Limited Client understands that this Limited Scope Agreement will
            be deemed to have been made in the State of Missouri. To the extent
            not inconsistent with Federal law, this Limited Scope Agreement
            shall be governed by and construed in accordance with the laws of
            Missouri, and in compliance with the Investment Advisers Act of
            1940. The federal and state securities laws impose liabilities under
            certain circumstances on persons who act in good faith, and
            therefore nothing herein shall in any way constitute a waiver or
            limitation of rights which Limited Client may have under federal and
            state securities laws.
          </p>
          <p>
            d. If any provision of this Limited Scope Agreement is held to be
            invalid, void, or unenforceable by reason of any law, rule,
            administrative order or judicial decision, that determination will
            not affect the validity of the remaining provisions of this Limited
            Scope Agreement.
          </p>
          <p>
            e. Except as specifically permitted in this Limited Scope Agreement,
            no provision of the Limited Scope Agreement can be, nor will it be
            deemed to be, waived, altered, modified, or amended unless agreed to
            in writing signed by an authorized officer of Advisor.
          </p>
          <p>
            f. Advisor may amend this Limited Scope Agreement by modifying or
            rescinding any of its existing provisions or by adding new
            provisions. Any such amendment shall be effective as of the time
            Advisor has notified Limited Client in writing of any change or such
            later date as Advisor may establish. Limited Client understands that
            the normal method of notifying Limited Client of modifications to
            the Limited Scope Agreement will be to post the information on the
            Website. Limited Client understands that by not closing and/or
            continuing to use the Services, Limited Client confirms Limited
            Client’s agreement to abide by the Limited Scope Agreement, as
            amended from time to time. Limited Client also agrees that Advisor
            may change the Service at any time and that it is not obligated to
            provide Limited Client with notice of such a change.
          </p>
          <p>
            g. In addition to the terms in this Agreement, when using products,
            services or features on the Website and Platform, Limited Client
            shall be subject to any additional posted guidelines, disclosures,
            methodology documents, or requirements applicable to such product,
            service or feature, which may be posted and modified from time to
            time. All such additional terms are hereby incorporated by reference
            into this Limited Scope Agreement.
          </p>
          <p>
            h. Advisor’s failure to insist on strict compliance with this
            Limited Scope Agreement or any other course of conduct on Advisor’s
            part will not be deemed a waiver of Advisor’s rights under this
            Limited Scope Advisory Agreement.
          </p>
          <p>
            i. The parties hereby acknowledge and agree that this Limited Scope
            Agreement alone, and the other documents agreed to and delivered in
            connection with becoming and continuing to be a Limited Client,
            constitutes the final understanding between the parties with respect
            to all matters contained herein. This Limited Scope Agreement, all
            other written agreements and terms contained on statements and
            confirmations contain the entire understanding between Advisor and
            Limited Client. Advisor may not assign its rights and duties under
            this Limited Scope Advisory Agreement to any of its successors,
            subsidiaries, affiliates, or any other entity without obtaining
            Limited Client’s consent. Limited Client will be deemed to have
            consented to Advisor assigning its rights and duties under this
            Limited Scope Agreement if after receiving adequate written
            electronic notice of a proposed assignment Limited Client does not
            serve notice of objection to Advisor. Limited Client may not assign
            the rights and obligations under this Limited Scope Advisory
            Agreement without first obtaining the prior written consent of
            Advisor. Any purported assignment in violation of this Limited Scope
            Agreement will be void.
          </p>
          <p>
            j. This Limited Scope Agreement will pass to the benefit of Advisor
            and its successors, assigns, and agents. In addition, Limited Client
            hereby agrees that this Limited Scope Agreement and all the terms
            hereof, will be binding on Limited Client’s heirs, executors,
            administrators, personal representatives, and any assigns permitted
            by Advisor.
          </p>
          <p>
            k. The heading of each provision of this Limited Scope Advisory
            Agreement is for descriptive purposes only and will not be deemed to
            modify or qualify any of the rights or obligations set forth in each
            such provision.
          </p>
          <p>
            l. Limited Client understands and agrees that Advisor may in its
            discretion, but is not obligated to, monitor or record any of
            Limited Client’s telephone conversations with Advisor for quality
            control and regulatory compliance purposes and for its own
            protection. Advisor may also monitor and make a record of Limited
            Client’s use of Services and any other communications between
            Advisor and Limited Client and may use the resulting information for
            internal purposes or as may be required by applicable law. Unless
            otherwise agreed in writing, Advisor does not consent to the
            recording of telephone conversations by any third party or Limited
            Client. Limited Client acknowledges and understands that not all
            telephone lines or calls are recorded by Advisor and does not
            guarantee that recordings of any particular telephone calls will be
            retained or capable of being retrieved.
          </p>
        </div>
        <div className="paragraph">
          <h3>
            CLIENT ACKNOWLEDGES THAT THEY ARE SIGNING A LEGAL DOCUMENT FOR THE
            ADVISORY SERVICES REPRESENTED HEREIN, AND PROVIDED A RECEIPT OF A
            COPY OF THIS ADVISORY AGREEMENT{" "}
          </h3>
        </div>
      </LimitedScopeWrapper>
    </>
  );
};

export default LimitedScope;
